/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Outlook_Humanize_UndoInputs */



/**
* | output |
* | --- |
* | "Undo rewrite" |
*
* @param {Chat_Outlook_Humanize_UndoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_outlook_humanize_undo = /** @type {((inputs?: Chat_Outlook_Humanize_UndoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Outlook_Humanize_UndoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Umformulierung rückgängig")
	return /** @type {LocalizedString} */ ("Undo rewrite")
});